import React from "react";
import { useTranslation } from "react-i18next";

import {
  LocationReviewSummary,
  LocationReviewSummaryStatus,
} from "../../../../models/LocationReviewSummary";
import "./styles.scss";

interface IReviewSummarySummarySectionProps {
  summary: LocationReviewSummary | undefined;
}

export const ReviewSummarySummarySection = ({
  summary,
}: IReviewSummarySummarySectionProps) => {
  const { t: _t } = useTranslation();
  const t = (key: string, params = {}) =>
    _t(`facilityDetailsPage.reviewSummary.summarySection.${key}`, {
      ...params,
    });

  if (summary?.status === LocationReviewSummaryStatus.NOT_ENOUGH_REVIEWS) {
    return (
      <div className="not-enough-reviews-block">
        <div className="not-enough-reviews-badge">
          {t("not_enough_reviews_badge")}
        </div>
        <div className="not-enough-reviews-title">
          {t("not_enough_reviews_title")}
        </div>
        <div className="not-enough-reviews-description">
          {t("not_enough_reviews_description_prefix")}
          <span className="not-enough-reviews-highlight">
            {t("not_enough_reviews_description_highlight")}
          </span>
          {t("not_enough_reviews_description_suffix")}
        </div>
        <div className="not-enough-reviews-divider" />
        <div className="not-enough-reviews-tip">
          {t("not_enough_reviews_tip")}
        </div>
      </div>
    );
  }

  if (!summary || summary.status !== LocationReviewSummaryStatus.SUCCESS) {
    return (
      <div className="summary">{t(summary?.status ?? "unknown_status")}</div>
    );
  }
  return <div className="summary">{summary?.summary?.summary}</div>;
};
